export const REQUEST_LOADING = 'ViewQuote/LOADING';
export const REQUEST_SUCCESS = 'ViewQuote/SUCCESS';
export const REQUEST_FAILURE = 'ViewQuote/FAILURE';
